import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DeleteDeposit, DoDeposit, GetExchangeData, GetEventList } from '../../common/actions/moreAction';
import Pagenation from '../common/Pagenation';
import NavLink from 'react-router-dom/NavLink';
import DepositDetailsContentElse from './DepositDetailsContentElse';
import WithdrawalDetailsContentElse from './WithdrawalDetailsContentElse';
import { dateFormation, isEmpty } from '../../common/cores';
const MoneyDetailsContent = (props) => {

    const [money, setMoney] = useState(0);
    const [showHis, setShowHis] = useState(false);

    const lists = props.pointexchange.data;
    const { page, user } = props;
    let ids = [];
    const [type, setType] = useState(1);
    const onResetType = (val) => {
        setType(val)
    };

    const getLists = (page) => {
        props.GetExchangeData(page);
    }
    console.log(lists)
    if (user.isAuthenticated == false) {
        window.location.href = "/login"
    }


    useEffect(() => {
        getLists();
    }, [props.user.isAuthenticated, props.page.perPage])

    return (
        <Fragment>
            <div className="con_box10">
                <div className="how_point">
                    <ul>
                        <li>잔여포인트<span>{!isEmpty(user.data.balance) && Number(user.data.balance.rolling).toLocaleString()}</span></li>
                    </ul>
                </div>
            </div>
            <div className="con_box10">
                <table width="100%" border="0" cellSpacing="0" cellPadding="0" style={{ borderSpacing: "0" }}>
                    <tbody>
                        <tr>
                            <td width="10%" className="list_title1">번호</td>
                            <td width="10%" className="list_title1">처리일시</td>
                            <td width="10%" className="list_title1">신청포인트</td>
                            <td width="10%" className="list_title1">전환후 머니</td>
                        </tr>
                        {
                            lists.map((list, index) => {
                                return (
                                    <tr key={index}>
                                        <td className="list1"><span className="text">{Number(page.curPage) * 10 - 9 + index}</span></td>
                                        <td className="list1"><span className="text">{dateFormation(list.date)}</span></td>
                                        <td className="list1"><span className="text">{Number(list.balance.amount).toLocaleString()} </span></td>
                                        <td className="list1"><span className="text">{Number(list.balance.after_money).toLocaleString()}</span></td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
            <Pagenation page={page.curPage}
                totalPage={page.totalPage}
                getPage={getLists}
                perPage={10} />
        </Fragment>

    );
};

const mapStateToProps = state => ({
    user: state.user,
    pointexchange: state.more.pointexchange,
    page: state.page
})

export default connect(mapStateToProps, { GetExchangeData, DoDeposit, DeleteDeposit })(MoneyDetailsContent);


// WEBPACK FOOTER //
// ./src/components/account/PointDetailsContent.js